import "./LandClearing.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import WhatIsLandClearing from "./sections/WhatIsLandClearing";
import HowLandClearingIsAchieved from "./sections/HowLandClearingIsAchieved";
import BenefitsOfLandClearing from "./sections/BenefitsOfLandClearing";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function LandClearingPage() {
  return <div>
      <Header />
      <Hero />
      <WhatIsLandClearing />
      <HowLandClearingIsAchieved />
      <BenefitsOfLandClearing />
      <CallToAction />
      <Footer />
    </div>;
}